import { CartActions } from './CartSlice';

export const { updateCart } = CartActions;
